import React from 'react';
import MenuItemComponent, { MenuItem } from './MenuItem';

interface MenuProps {
  items: MenuItem[];
  level?: number;
}

const Menu: React.FC<MenuProps> = ({ items, level = 0 }) => (
  <div className="dropdown-menu" style={level > 0 ? { left: '100%', top: 0, minWidth: 180 } : {}}>
    {items.map((item, idx) =>
      item.submenu ? (
        <div key={(item.label || '') + idx} style={{ position: 'relative' }}>
          <MenuItemComponent item={item} level={level} />
          <div className="dropdown-menu submenu" style={{ display: 'none', position: 'absolute', left: '100%', top: 0, minWidth: 180 }}>
            <Menu items={item.submenu} level={level + 1} />
          </div>
        </div>
      ) : (
        <MenuItemComponent key={(item.label || '') + idx} item={item} level={level} />
      )
    )}
  </div>
);

export default Menu; 